<div class="zoom-wrapper">
    <div class="zoom-content">
        @if(applicationStatus === 'Loading'){
        <app-spinner [spinnerName]="initialLoaderName" [fullScreen]="true"></app-spinner>
        }@else if(applicationStatus === 'Render'){
        <section class="app-container">
            <app-header class="app-header" [navbarComponent]="navbarComponent" />
            <div class="app-content">
                <app-navbar></app-navbar>
            </div>
            <app-footer class="app-footer" />
        </section>
        }@else{
        <error-page [errorMsg]="errorPageConfig"></error-page>
        }
        <app-spinner [spinnerName]="spinnerArea['FullScreen']" [fullScreen]="true"></app-spinner>
        <app-custom-tour></app-custom-tour>
    </div>
</div>



<!-- chat bot  -->
<!-- <button class="help-icon" mat-icon-button aria-label="Help" (click)="openHelp()">
  <mat-icon>chat</mat-icon>
</button> -->
